import Button from 'components/Button';
import Textarea from 'components/form/Inputs/Textarea';
import FilePlusIcon from 'components/icons/FilePlus';
import { FC, useCallback, useMemo } from 'react';
import styled from 'styled-components';

const TextareaContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  height: fit-content;

  @media (max-width: 900px) {
    width: calc(100% + 1rem);
    margin-left: -0.5rem;
  }

  & > * {
    margin-left: 0.5rem;
  }

  & > div:first-child {
    margin-left: 0;
    stroke: var(--gray-600);
    cursor: pointer;
    height: calc(2px + 1.6rem + 1.25rem);
    display: flex;
    place-items: center;
  }

  & > div:nth-child(2) {
    flex-grow: 1;
  }

  & > div:last-child {
    height: calc(2px + 1.6rem + 1.25rem);
    display: flex;
    place-items: center;
  }
`;

type Props = {
  value: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  handleSubmit: () => void;
  disabled: boolean;
  submitting: boolean;
  openFileForm: () => void;
};
const MessageInput: FC<Props> = ({
  value,
  onChange,
  handleSubmit,
  disabled,
  submitting,
  openFileForm,
}) => {
  const isValueEmpty = useMemo(
    () => !(value as string)?.replace(/\s/g, ''),
    [value],
  );
  const fireSubmit = useCallback(
    () => !disabled && handleSubmit?.(),
    [disabled, handleSubmit],
  );
  return (
    <>
      <TextareaContainer>
        <div
          onClick={openFileForm}
          style={{ width: isValueEmpty ? 'auto' : 0 }}
        >
          <FilePlusIcon />
        </div>
        <Textarea
          placeholder="Envoyer un message"
          autoFocus
          maxLength={950}
          {...{
            value,
            onChange,
            disabled,
            handleSubmit,
          }}
          rows={value.length ? 3 : 1}
        />
        <div>
          <Button
            color="primary"
            onClick={fireSubmit}
            disabled={disabled || (isValueEmpty && !submitting)}
            loading={submitting}
          >
            Envoyer
          </Button>
        </div>
      </TextareaContainer>
    </>
  );
};

export default MessageInput;
